import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import InputPeople from "./InputPeople"
import { useTour } from "@/hooks/tour/useTour"
import { useMemo } from "react"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { Col } from "antd"
import { useTranslation } from "react-i18next"
import _ from "lodash"

const InputChd2 = () => {

  const inputChd = useAppSelector(state => state.tour.inputTour.inputChd2)
  const selectedDepartureSchedule = useAppSelector(state => state.tour.inputTour.selectedDepartureSchedule)
  const { tour: { data: tour } } = useTour()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const priceChd = useMemo(() => {
    if (!selectedDepartureSchedule) {
      return 0
    }
    const departureSchedule: any = tour?.departureSchedule?.find(d => d.id === selectedDepartureSchedule)
    return departureSchedule?.prices[0]?.priceChd2
  }, [selectedDepartureSchedule, tour?.departureSchedule])

  if (!tour.agesChildren2From || !tour.agesChildren2To) {
    return <></>
  }

  return (
    <Col span={24}>
      <InputPeople
        label={`${t("common.child")} 2`}
        subLabel={`${tour.agesChildren2From} - ${tour.agesChildren2To} ${_.lowerFirst(t("common.years_old"))}`}
        value={inputChd}
        price={priceChd}
        onChange={(val) => dispatch(tourActions.inputPeople({ type: 'CHD2', value: val }))}
      />
    </Col>
  )
}

export default InputChd2